// src/pages/usa/colorado/Idaho Springs.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Idaho Springs ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function IdahoSprings() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__idahoSpringsBackRouteSet) {
      window.__idahoSpringsBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Idaho Springs, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>Discover Idaho Springs, Colorado</h2>

           <p>
  Idaho Springs is a charming mountain town tucked into the heart of the Colorado Rockies, just a short drive from Denver. 
  Known for its rich mining history, vibrant local culture, and stunning natural scenery, the town blends old‑world charm 
  with outdoor adventure. Whether you're wandering through the historic downtown filled with cozy shops and restaurants, 
  relaxing in the natural hot springs, or hiking the surrounding peaks, Idaho Springs welcomes visitors with warmth, 
  character, and authenticity.
</p>

<p>
  Founded in the 1860s, the town’s mining heritage is still visible everywhere you look. The historic district is lined 
  with preserved buildings, museums, and landmarks that tell the story of Colorado’s gold‑rush era. One of the most iconic 
  stops is the Argo Gold Mine and Mill, where guided tours take you deep into the old tunnels and offer a fascinating 
  glimpse into the lives of the miners who once worked beneath these mountains.
</p>


            <h3>🚗 Getting There</h3>

            <p>
              To reach Idaho Springs, you can drive from Denver in about 45 minutes via I‑70 West. The route takes you through
              scenic mountain landscapes, and there are several pull‑offs along the way where you can stop for photos or a quick hike. 
              If you prefer not to drive, there are also shuttle services and guided tours that depart from Denver and other nearby cities.
            </p>

            

            {/* 🌟 MY PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                    <strong>The Town:</strong> Walking through the historic downtown is a delightful experience, filled with 
                    charming shops, cozy cafés, local restaurants, and even a small museum that reflects the town’s heritage. 
                    In my experience, the community has a warm and welcoming atmosphere — it feels safe, familiar, and full of 
                    character. From the coffee shop to the handmade soap store, every corner has its own personality. It’s a small 
                    town, but one that’s absolutely worth visiting for its history, friendliness, and simple mountain‑town charm. <br />
                  <a
                    href="https://www.google.com/maps?q=39.74227758821664, -105.51345886736301"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Idaho Springs Town
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Hot Springs:</strong> This area has been known for its natural mineral waters for well over a century. 
                  Early travelers, miners, and settlers used these springs for relaxation and healing long before modern facilities 
                  were built. Today, the hot springs remain one of the town’s most iconic attractions, offering a mix of history, 
                  wellness, and mountain scenery.

                   The main public pool is naturally heated and rich in minerals, making it perfect for soaking after a 
                   long day of exploring. For a more private experience, the facility also offers individual soaking rooms 
                   where you can enjoy the warm waters in a quieter setting. One of the most unique features is the separate 
                   men’s and women’s caverns — natural steam-filled rock chambers that have been used for generations. 
                   These underground baths create a rustic, old‑world spa atmosphere that you won’t find anywhere else.

                    Whether you choose the large public pool, a private room, or the historic caverns, the hot springs offer a 
                    relaxing and memorable experience surrounded by Colorado’s mountain beauty..<br />
                  <a
                    href="https://www.google.com/maps?q=39.739276679806274, -105.51268010108842"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Hot Springs
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                 <strong>The Argo Gold Mill and Tunnel:</strong> The Argo Gold Mill and Tunnel is one of the most important historic
                  mining sites in Colorado, offering a vivid look into the region’s gold‑rush era. Built in the late 1800s, the Argo
                   Tunnel was engineered to drain water from the surrounding mines and allow miners to access deeper veins of gold. 
                   At the time, it was considered a remarkable feat of engineering — stretching more than four miles through solid rock.

                   The mill itself processed millions of dollars’ worth of ore, using massive machinery that still stands today. 
                   Walking through the site feels like stepping back into the early days of Colorado’s mining boom. The tour showcases 
                   original tools, equipment, and techniques used by miners who worked long hours in dangerous conditions, hoping to 
                   strike it rich.

                   Today, the Argo is beautifully preserved as a museum and educational experience. Visitors can explore the mill, learn 
                   how gold was extracted, and even try their hand at gold panning. It’s a fascinating stop that brings the state’s 
                   mining history to life and helps you appreciate the grit, innovation, and determination that shaped these mountain 
                   towns.<br />
                  <a
                    href="https://www.google.com/maps?q=39.74260050229078, -105.50691159885992"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 The Argo Mines
                  </a>
                </div>
              </li>

             

            </ul>

            {/* 🏔️ HIDDEN GEMS */}
           🏔️ Hidden Gems in Idaho Springs
<ul>

<li>
<div className="place-block">
<strong>St. Mary’s Glacier:</strong> A stunning permanent snowfield just outside Idaho Springs. The short hike leads to an alpine lake surrounded by rugged peaks, making it one of the area’s most photographed hidden gems. 
</div>
</li>

<li>
<div className="place-block">
<strong>Clear Creek Whitewater Rafting:</strong> Idaho Springs is one of Colorado’s top rafting hubs. Clear Creek offers beginner‑friendly rapids as well as more intense sections, all guided by local outfitters. It’s one of the most exciting ways to experience the canyon. 
</div>
</li>

<li>
<div className="place-block">
<strong>Phoenix Gold Mine:</strong> A real, historic gold mine where you can walk through old tunnels, learn about mining geology, and even pan for gold. It’s a quieter, more intimate alternative to the larger Argo Mill. 
</div>
</li>

<li>
<div className="place-block">
<strong>Indian Hot Springs Caverns:</strong> Beyond the main geothermal pool, the hidden gem here is the natural vapor caves — steam‑filled rock chambers used since the early 1900s. Private soaking rooms and mineral‑water jacuzzis are also available. 
</div>
</li>



</ul>

{/* 🛏️ PLACES TO STAY */}
<h3>🛏️ Places to Stay in Idaho Springs</h3>

<p>
  Idaho Springs offers cozy mountain stays, historic hotels, and unique hot‑spring
  lodging. These top‑ranked options include both Expedia/Booking listings and
  beloved independent stays.
</p>

<ul>
  <li>
    <div className="place-block">
      <strong>Indian Hot Springs Resort (Direct Booking):</strong> Rustic rooms,
      private baths, and access to geothermal caves and mineral pools.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>JC Suites (Direct Booking):</strong> Spacious, clean, and centrally
      located on Miner Street. Great value and walkable to restaurants and shops.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>H&H Motor Lodge (Booking/Expedia):</strong> Simple, well‑kept lodge
      with friendly service and consistently solid guest reviews.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Argo Inn & Suites (Booking/Expedia):</strong> Creekside views and
      comfortable rooms next to the historic Argo Mill.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Columbine Inn (Booking/Expedia):</strong> Classic roadside inn with
      clean rooms, mountain views, and strong ratings for comfort and value.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Uplift Inn (Booking/Expedia):</strong> Boutique‑style stay with modern
      rooms and a peaceful atmosphere. Highly rated for cleanliness and comfort.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Miners Pick Bed & Breakfast (Direct Booking):</strong> Charming B&B
      with homemade breakfast and warm hospitality.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Silver Lake Lodge (Booking/Expedia):</strong> Luxury adults‑only
      mountain lodge above Idaho Springs. Romantic and secluded.
    </div>
  </li>
</ul>


            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Grottos Ice Cave and Ashcroft Ghost Town.</p>

        <p>
  <a
    href="https://youtu.be/MAogFRBcxYg?si=EzO3CU42aqovTkgk"
    target="_blank"
    rel="noopener noreferrer"
  >Idaho Springs Town 360 Video
  </a>
</p>

<p>
  <a
    href="https://youtu.be/4zwZpZuFxE0?si=Rn7Ffy5nf7HW0Scd"
    target="_blank"
    rel="noopener noreferrer"
  >
    Charles Taylor Water Wheel Video
  </a>
</p>
<p>
  <a
    href="https://youtu.be/GcXwg0eOzIw?si=KD1l6iNjGcU_teC8"
    target="_blank"
    rel="noopener noreferrer"
  >
    Idaho Springs Town Video
  </a>
</p>


</div>

{/* RIGHT COLUMN — IMAGES */}
<div className="travel-image-column">
  <a
    href="https://youtu.be/4zwZpZuFxE0?si=qSE-VjeczIFu0On2"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/idahosprings/wat2.jpg"
      alt="Charles Taylor Water Wheel Video"
    />
  </a>

  <a
    href="https://youtu.be/GcXwg0eOzIw?si=oS95yPLxyLyDs3-G"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
       src="/images/usa/colorado/idahosprings/town2.jpg"
      alt="Idaho Springs Town Video"
    />
  </a>

 



  <img src="/images/usa/colorado/idahosprings/train.jpg" alt="Train in Town" />
  <img src="/images/usa/colorado/idahosprings/ww.jpg" alt="Water Wheel" />
  <img src="/images/usa/colorado/idahosprings/mill.jpg" alt="Idaho Springs Water Wheel" />
  <img src="/images/usa/colorado/idahosprings/town.jpg" alt="Idaho Springs Town" />
  <img src="/images/usa/colorado/idahosprings/town1.jpg" alt="Idaho Springs Town" />
  <img src="/images/usa/colorado/idahosprings/town2.jpg" alt="Idaho Springs Town" />
  <img src="/images/usa/colorado/idahosprings/light.jpg" alt="Idaho Springs Town" />
  <img src="/images/usa/colorado/idahosprings/hp.jpg" alt="Idaho Springs Hot Springs" />
  <img src="/images/usa/colorado/idahosprings/argo.jpg" alt="Argo Mine Tours" />
 
</div>
</section>
</div>

{/* Centered email button */}
<div className="email-wrapper">
  <button className="email-link" onClick={() => setOpen(true)}>
    contact@thefindingspot.com
  </button>
</div>

{/* Popup */}
<ContactPopup isOpen={open} onClose={() => setOpen(false)} />

<Footer />
</>
);
}
